<template>
  <v-container fluid pa-0>
    <v-flex xs12 style="font-size: 36px; font-weight: 700">
      Edit Profile
    </v-flex>
    <v-card class="elevation-0" secondary style="display: flex; align-items: center; justify-content: center; padding: 60px 20%; flex: none; flex-direction: column; margin-top: 60px">
      <div xs12 style="font-size: 24px; font-weight: 700">Personal Information</div>
      <img src="@/assets/user.png" style="width: 100px; height: 100px; margin-top: 20px;" />
      <v-form>
        <v-text-field autofocus single-line solo flat ref="firstName" placeholder="First Name" v-model="firstName" :error-messages="firstNameErrorMsgs" required @blur="$v.firstName.$touch()" class="editFormField" style="margin: 20px 0" color="accent"></v-text-field>
        <v-text-field single-line solo flat ref="lastName" placeholder="Last Name" v-model="lastName" :error-messages="lastNameErrorMsgs" required @blur="$v.lastName.$touch()" class="editFormField" style="margin: 20px 0" color="accent"></v-text-field>
        <v-text-field single-line solo flat ref="email" placeholder="Email" v-model="email" :error-messages="emailErrorMsgs" required @blur="$v.email.$touch()" class="editFormField" style="margin: 20px 0" color="accent"></v-text-field>
        <div style="text-align: center">
          <v-btn :disabled="updateBtnDisabled" large round @click="submitUpdateForm()" class="primary secondary--text mt-4" :ripple="false" style="width: 180px;height: 45px;" :loading="updateLoadingState === 'loading'">Save</v-btn>
        </div>
      </v-form>
    </v-card>
    <v-card class="elevation-0" secondary style="display: flex; align-items: center; justify-content: center; padding: 60px 20%; flex: none; flex-direction: column; margin-top: 60px">
      <div xs12 style="font-size: 24px; font-weight: 700">Password</div>
      <v-form>
        <div @click="editPasswordDialog = true" style="cursor: pointer">
          <v-text-field disabled single-line solo type="password" flat ref="password" class="editFormField passwordSuffix" style="margin: 20px 0" v-model="maskedPassword" suffix="change"></v-text-field>
        </div>
      </v-form>
    </v-card>
    <v-card class="elevation-0" secondary style="display: flex; align-items: center; justify-content: center; padding: 60px 20%; flex: none; flex-direction: column; margin-top: 60px">
      <div xs12 style="font-size: 24px; font-weight: 700">Organizations</div>
      <v-layout row style="margin-top: 20px" v-if="getUserOrganization && currentUser && currentUser.organizations && currentUser.organizations.length > 0">
        <v-flex v-for="item in currentUser.organizations" :key="item.id" style="text-align: center; min-width: 120px; display: flex; flex-direction: column; align-items: center; cursor: pointer" class="mx-4 organizationObject" :class="getUserOrganization.id === item.id ? 'selected' : 'regular'" @click="getOrganizationData(item.id)">
          <div style="height: 100px; width: 100px; border-radius: 100%; font-size: 48px; font-weight: 300; border: 1px solid; display: flex; align-items: center; justify-content: center; margin-bottom: 10px" class="organizationAvatar">{{item.name[0]}}</div>
          <div style="font-size: 18px" class="organizationName">{{item.name}}</div>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="editPasswordDialog" fullscreen>
      <v-card style="display: flex; align-items: center; justify-content: center; flex-direction: column" v-if="dialogDisplay === 'edit'">
        <v-btn small icon light @click="closeDialog()" style="text-align: right; position: absolute; top: 40px; right: 40px; padding: 0; margin: 0">
          <v-icon>close</v-icon>
        </v-btn>
        <div>
          <v-flex style="font-size: 36px; font-weight: 300" class="primary--text">Change Password</v-flex>
          <v-form>
            <v-text-field single-line solo flat type="password" ref="currentPassword" placeholder="Current Password*" v-model="currentPassword" :error-messages="currentPasswordErrorMsgs" required @blur="$v.currentPassword.$touch()" class="editFormField" style="margin: 20px 0" color="accent"></v-text-field>
            <v-text-field single-line solo flat type="password" ref="password" placeholder="New Password*" v-model="password" :error-messages="passwordErrorMsgs" required @blur="$v.password.$touch()" class="editFormField" style="margin: 20px 0" color="accent"></v-text-field>
            <v-text-field single-line solo flat type="password" ref="confirmPassword" placeholder="Confirm Password*" v-model="confirmPassword" :error-messages="confirmPasswordErrorMsgs" required @blur="$v.confirmPassword.$touch()" class="editFormField" style="margin: 20px 0" color="accent"></v-text-field>
          </v-form>
          <div style="text-align: right">
            <v-btn large round @click="submitPasswordForm()" class="primary secondary--text mt-4" :ripple="false" style="width: 180px;height: 45px;" :loading="updateLoadingState === 'loading'">Change</v-btn>
          </div>
        </div>
      </v-card>
      <v-card style="display: flex; align-items: center; justify-content: center; flex-direction: column" v-if="dialogDisplay === 'success'">
        <div style="text-align: left">
          <img src="@/assets/check.png" style="margin-bottom: 20px; max-height: 190px; margin: 0; padding: 0">
          <v-flex xs12 style="font-size: 36px; font-weight: 700" class="primary--text">Success!</v-flex>
          <v-flex xs12 style="font-size: 18px;" class="primary--text">Your have successfully changed your password.</v-flex>
          <v-btn flat round class="mt-5 primary doneBtn" :ripple="false" @click="closeDialog()">Done</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
  .organizationObject.regular, .organizationObject.regular .organizationName{
    color: #011E41;
  }
  .organizationObject.regular .organizationAvatar{
    border-color: #011E41;
  }
  .organizationObject.selected, .organizationObject.selected .organizationName{
    color: #2165FF;
  }
  .organizationObject.selected .organizationAvatar{
    border-color: #2165FF;
  }
  .editFormField{
    border-radius: 50px;
    width: 450px;
    height: 60px;
  }
  .editFormField .v-input__slot{
    border: 1px solid #011E41;
    border-radius: 50px !important;
    padding-top: 0px !important;
    margin-bottom: 0 !important;
    padding-left: 20px !important;
    font-size: 18px;
  }
  .editFormField .v-input__slot input{
    color: #011E41 !important;
    line-height: 1;
  }
  .editFormField .v-text-field__details{
    padding-left: 22px !important;
    margin-top: 2px !important
  }
  .passwordSuffix .v-text-field__suffix{
    font-size: 14px;
    color: #011E41;
  }
  .passwordSuffix{
    cursor: pointer;
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import vh, { firstName, lastName, email, password, confirmPassword, currentPassword } from '@/helpers/validators'
import axios from 'axios'
import underscore from 'underscore'

export default{
  data () {
    return {
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      confirmPassword: '',
      currentPassword: '',
      user: null,
      updateLoadingState: 'none',
      maskedPassword: 'password',
      editPasswordDialog: false,
      currentPasswordNoMatch: false,
      dialogDisplay: 'edit'
    }
  },
  validations: {
    email: vh.vrules(email),
    firstName: vh.vrules(firstName),
    lastName: vh.vrules(lastName),
    password: vh.vrules(password),
    confirmPassword: vh.vrules(confirmPassword, password),
    currentPassword: vh.vrules(currentPassword)
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({getUserOrganization: 'getUserOrganization'}),
    firstNameErrorMsgs () {
      if (this.$v.firstName.$dirty) {
        return vh.vmsg(this.$v.firstName, firstName)
      } else {
        return []
      }
    },
    lastNameErrorMsgs () {
      if (this.$v.lastName.$dirty) {
        return vh.vmsg(this.$v.lastName, lastName)
      } else {
        return []
      }
    },
    emailErrorMsgs () {
      if (this.$v.email.$dirty) {
        return vh.vmsg(this.$v.email, email)
      } else {
        return []
      }
    },
    currentPasswordErrorMsgs () {
      if (this.$v.currentPassword.$dirty) {
        if (this.currentPasswordNoMatch && this.currentPassword === '') {
          return 'Current Password incorrect'
        }
        return vh.vmsg(this.$v.currentPassword, currentPassword)
      } else {
        return []
      }
    },
    passwordErrorMsgs () {
      if (this.$v.password.$dirty) {
        return vh.vmsg(this.$v.password, password)
      } else {
        return []
      }
    },
    confirmPasswordErrorMsgs () {
      if (this.$v.confirmPassword.$dirty) {
        return vh.vmsg(this.$v.confirmPassword, confirmPassword)
      } else {
        return []
      }
    },
    updateBtnDisabled () {
      if (this.user) {
        return this.firstName === this.user.firstName && this.lastName === this.user.lastName && this.email === this.user.email
      }
      return true
    }
  },
  methods: {
    ...mapMutations('auth', ['setUser']),
    ...mapMutations('notification', ['notify']),
    submitUpdateForm () {
      this.user.firstName = this.firstName
      this.user.lastName = this.lastName
      this.user.email = this.email
      axios.all([this.$store.dispatch('updateUser', this.user)]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.user = JSON.parse(JSON.stringify(response.data.payload))
          this.email = response.data.payload.email
          this.firstName = response.data.payload.firstName
          this.lastName = response.data.payload.lastName
          this.setUser(response.data.payload)
          this.updateLoadingState = 'none'
        } else {
          this.updateLoadingState = 'none'
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.updateLoadingState = 'none'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    async submitPasswordForm () {
      this.updateLoadingState = 'loading'
      try {
        var data = { email: this.$data.user.email.toLowerCase(), password: this.$data.currentPassword }
        await this.$store.dispatch('auth/login', { ...data })
        this.$v.$touch()
        if (this.$v.password.$invalid || this.$v.confirmPassword.$invalid) {
          this.updateLoadingState = 'none'
          return
        }
        this.user.password = this.password
        axios.all([this.$store.dispatch('updateUser', this.user)]).then(axios.spread((response) => {
          if (response.data.status === 'SUCCESS') {
            this.dialogDisplay = 'success'
            this.updateLoadingState = 'none'
          } else {
            this.updateLoadingState = 'none'
            this.notify({message: 'Something went wrong.', show: true})
          }
        })).catch((err) => {
          this.updateLoadingState = 'none'
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      } catch (e) {
        this.updateLoadingState = 'none'
        this.currentPassword = ''
        this.currentPasswordNoMatch = true
        this.$v.$touch()
      }
    },
    closeDialog () {
      this.editPasswordDialog = false
      this.currentPassword = ''
      this.password = ''
      this.confirmPassword = ''
      this.currentPasswordNoMatch = false
      this.updateLoadingState = 'none'
      this.dialogDisplay = 'edit'
    },
    getOrganizationData (id) {
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  mounted () {
    if (this.currentUser) {
      this.email = this.currentUser.email
      this.firstName = this.currentUser.firstName
      this.lastName = this.currentUser.lastName
      this.user = JSON.parse(JSON.stringify(this.currentUser))
    }
  },
  watch: {
    currentUser: function (newVal, oldVal) {
      if (!underscore.isEqual(newVal, oldVal)) {
        this.email = this.currentUser.email
        this.firstName = this.currentUser.firstName
        this.lastName = this.currentUser.lastName
        this.user = JSON.parse(JSON.stringify(this.currentUser))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/Profile.vue